import { type Profession, createProfession } from 'models';
import { useQuery } from 'query';
import { getProfessions } from '../services';
import { getProfessionsQueryKey } from './keys';

export const useProfessions = () =>
  useQuery<Profession[]>({
    async queryFn() {
      const { data } = await getProfessions();
      return data.map((profession) => createProfession(profession));
    },
    queryKey: getProfessionsQueryKey(),
  });
